import { createSlice } from "@reduxjs/toolkit";

import { API_ENV } from "../../constants";

const INITIAL_STATE = {
  environment: API_ENV.DEV,
};

const configSlice = createSlice({
  name: "config",
  initialState: INITIAL_STATE,
  reducers: {
    toggleSwitchEnvAction: (state, action) => {
      state.environment = state.environment === API_ENV.DEV
        ? API_ENV.PRD
        : API_ENV.DEV;
    },
  },
})

export const {
  toggleSwitchEnvAction,
} = configSlice.actions;

export default configSlice.reducer;
